import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-11 min-h-[44px] w-full rounded-xl border-2 border-primary/20 bg-white/90 py-3 text-base sm:text-sm transition-smooth",
          "text-foreground placeholder:text-muted-foreground/70 backdrop-blur-sm",
          "hover:border-primary/40 hover:bg-white hover:shadow-sm",
          "focus-visible:outline-none focus-visible:border-primary focus-visible:bg-white focus-visible:shadow-sm focus-visible:ring-2 focus-visible:ring-primary/20",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted/30",
          "dark:bg-card/80 dark:border-border/40 dark:hover:bg-card/90 dark:focus-visible:bg-card dark:hover:border-primary/60",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          // Default horizontal padding, but allow override via className
          !className?.includes('px-') && !className?.includes('pl-') && !className?.includes('pr-') ? 'px-4' : '',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
